import copy from './en.json';
import copyJS from './en';
import merge from 'lodash/merge';

export const {
    dimensions,
    landingCards,
    legacyTooltips,
    MARKETS,
    SEOMetaTags,
    signupSlides,
    tooltips,
    VERTICALS,
    views,
    timeseries,
    whatIsSpate,
    modals,
} = merge({}, copy, copyJS);
